import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { InputRatingComponent } from '../../components/input-rating/input-rating.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-symptom-check-feedback',
	templateUrl: './modal-symptom-check-feedback.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputAutocompleteComponent, InputRatingComponent, FormsModule ]
})
export class ModalSymptomCheckFeedbackComponent implements OnInit {
	private config: Config = inject(Config);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	private dialogRef = inject(MatDialogRef<ModalSymptomCheckFeedbackComponent>);
	private data = inject(MAT_DIALOG_DATA);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.uid = 'mscf-' + this.vm.ref;
		this.vm.maxRating = 10;
		this.vm.commentMaxLength = 1000;
		
		this.getFeedback();
		
		this.vm.close = this.close;
		this.vm.submitFeedback = this.submitFeedback;
		this.vm.searchConditions = this.searchConditions;
	}
	
	getFeedback() {
		this.restService.getInterviewRating({ interviewId: this.vm.interview.localId })
			.then((res) => {
				this.vm.feedback = res || {};
				this.vm.isInitialized = true;
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	searchConditions = (input) => {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		
		this.restService.getConditionSearch({ phrase: input.namePart })
			.then((items) => {
				deferred.resolve(items);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});
		
		return deferred.promise;
	}
	
	submitFeedback(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid 
			|| !this.vm.feedback.condition
			|| !this.vm.feedback.rating 
			|| this.vm.isProcessing) return;
		
		this.vm.isProcessing = true;
		
		var feedback: any = this.angularHelperService.copy(this.vm.feedback);
		feedback.interview = { localId: this.vm.interview.localId };

		this.restService.saveInterviewRating(feedback)
			.then((res) => {
				this.angularBroadcastHelperService.rootBroadcast(
					this.config.getBroadcastConfig().Symptom_Check.RATING_UPDATED + this.vm.ref,
					{ rating: res }
				);
				this.close();
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	close() {
		this.dialogRef.close();
	}
	
}